import Vue from 'vue'
import address from './address/index.vue'
Vue.component('input-address', address);
import phone from './phone/index.vue'
Vue.component('input-phone', phone);
import sum from './sum/index.vue'
Vue.component('input-sum', sum);
